import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { ReactSVG } from 'react-svg';
import icons from '../constants/icons';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import dynamicfunction from '../utils/dynamicfunction';
import Button from './Button';

const SuccessModal = ({ title, open, onClose, description }) => {
  const { TextWeight } = dynamicfunction();

  return (
    <Dialog
      open={open}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogContent>
        <div className='px-4 sm:px-10'>
          <ReactSVG
            src={icons.success}
            className='flex items-center justify-center'
          />
          <Text
            text={title ?? ''}
            size={fontSizes.h20}
            className={'mt-4'}
            weight={TextWeight.bold}
            isCenter
            isTruncate={false}
          />

          {
            description && (
              <Text
                text={description ?? ''}
                size={fontSizes.h14}
                className={'mt-4'}
                color='text-text-grey/70'
                isCenter
                isTruncate={false}
              />
            )
          }          
          <Button
            text={'OK'}
            onClick={onClose}
            className={'px-10 mx-auto mt-3'}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
